import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import ImoApp from 'annuity_lab/tools/imo/components/imo_app/imo_app.js.jsx';

const mapStateToProps = ({auth}) => ({
    user: auth.user,
});

export default withRouter(connect(mapStateToProps)(ImoApp));